
// @ts-nocheck


export const localeCodes =  [
  "vi",
  "en"
]

export const localeLoaders = {
  vi: [
    {
      key: "locale_vi_46json_8b003526",
      load: () => import("#nuxt-i18n/8b003526" /* webpackChunkName: "locale_vi_46json_8b003526" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_dc341b85",
      load: () => import("#nuxt-i18n/dc341b85" /* webpackChunkName: "locale_en_46json_dc341b85" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/f5a966e5" /* webpackChunkName: "config_vue_45i18n_46config_46ts_f5a966e5" */)
]

export const nuxtI18nOptions = {
  restructureDir: "src",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "vi",
      name: "Tiếng Việt",
      files: [
        {
          path: "/app/apps/frontend/src/i18n/locales/vi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/app/apps/frontend/src/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "vi",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "i18n/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "vi",
    name: "Tiếng Việt",
    files: [
      {
        path: "/app/apps/frontend/src/i18n/locales/vi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/app/apps/frontend/src/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/